/* ========================================================================
   General
 ========================================================================== */

app.general = (function () {
  'use strict';

  function initEmailLinks() {
    // Handle base-64 encoded mailto-links
    const links = document.querySelectorAll('a[data-email]');

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        let email = atob(link.getAttribute('data-email'));
        window.location.href = 'mailto:' + email;
      });
    });
  }

  // function initLax() {
  //   lax.init();

  //   // Add a driver that we use to control our animations
  //   lax.addDriver('scrollY', function () {
  //     return window.scrollY;
  //   });

  //   lax.addElements('[data-lax]]', {
  //     scrollY: {
  //       translateY: [
  //         ['elInY', 'elOutY'],
  //         [0, -250],
  //       ],
  //     },
  //   });
  // }

  const updateViewportDimensions = util.debounce(() => {
    document.documentElement.style.setProperty('--vh', window.innerHeight + 'px');
    document.documentElement.style.setProperty('--vw', window.innerWidth + 'px');
  }, 250);

  function initViewportDimensions() {
    // Init viewport dimensions
    updateViewportDimensions();

    // Handle viewport dimensions on resize
    window.addEventListener(
      'resize',
      () => {
        updateViewportDimensions();
      },
      { passive: true }
    );
  }

  // let isTouch = false;
  // let isTouchTimer;
  // const isTouchClass = 'touch';

  // function addTouchClass() {
  //   window.clearTimeout(isTouchTimer);
  //   if (isTouch === true) return;

  //   isTouchTimer = window.setTimeout(() => {
  //     document.documentElement.classList.add(isTouchClass);
  //     isTouch = true;
  //   }, 250);
  // }

  // function removeTouchClass() {
  //   if (isTouch === false) return;

  //   document.documentElement.classList.remove(isTouchClass);
  //   isTouch = false;
  // }

  // function initTouch() {
  //   document.addEventListener('touchstart', addTouchClass, { passive: true });
  //   document.addEventListener('mouseup', removeTouchClass);
  // }

  function initAnchorLinks() {
    const links = document.querySelectorAll('a[href^="#"]');

    links.forEach((link) => {
      const href = link.getAttribute('href');
      if (href === '#') return;

      const target = document.querySelector(href);
      if (!target) return;

      link.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToTarget(target);
      });
    });

    // var gotoQs = util.getQueryString('goto');
    // if (gotoQs) {
    //   const target = document.querySelector('#' + gotoQs);
    //   if (!target) return;

    //   setTimeout(() => {
    //     scrollToTarget(target);
    //   }, 500);
    // }
  }

  function scrollToTarget(target) {
    const offset = 100;
    const top = target.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: top - offset,
      behavior: 'smooth',
    });
  }

  // Expose public functions and variables
  return {
    initEmailLinks: initEmailLinks,
    // initLax: initLax,
    initViewportDimensions: initViewportDimensions,
    updateViewportDimensions: updateViewportDimensions,
    // initTouch: initTouch,
    initAnchorLinks: initAnchorLinks,
  };
})();
